<template>
  <v-container fluid class="alert-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/alert/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="alerts-table"
              show-select
              single-select
              item-key="_id"
              sort-by="alertcode"
              :footer-props="footer"
              :headers="headers"
              :items="alerts"

              :items-per-page="alertPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteAlert"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Alert?
                    </v-card-title>
                    <v-card-text>
                      {{ deletealert.alertcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteAlert = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteAlert(deletealert)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.alertstatus="{ item }">
                <v-chip
                  :color="!item.alertstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.alertstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editAlert(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AlertList',
  data() {
    return {
      isDeleteAlert: false,
      deletealert: {},
      headers: [
        { text: 'Code', value: 'alertcode'},
        { text: 'Name', value: 'alertname'},
        { text: 'Type', value: 'alerttype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      alertPerPage: 100,
      selected: [],      
    }
  },
  computed: {
    ...mapState('Alert', ['alerts', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  async created () {
    await this.getAlertsRequest()
  },

  methods: {
    ...mapActions('Alert', [
      "createAlertRequest",
      "deleteAlertRequest",
      "getAlertsRequest",
      "updateAlertRequest",
    ]),
    editAlert(item) {
      this.$router.push({ name: 'AlertEdit', params: item })
    },
    deleteAlert(item) {
      this.deleteAlertRequest({_id: item._id});
      this.isDeleteAlert = false;
    },
    deleteDialog(item) {
      this.isDeleteAlert = true;
      this.deletealert = {
        _id: item._id,
        alertcode: item.alertcode,
      }
    },

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
